module.exports = __webpack_public_path__ + "static/media/indianapolis_team.e6d240e9.jpg";